/* eslint-disable @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any */
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 100] = "DEBUG";
    LogLevel[LogLevel["INFO"] = 200] = "INFO";
    LogLevel[LogLevel["NOTICE"] = 250] = "NOTICE";
    LogLevel[LogLevel["WARNING"] = 300] = "WARNING";
    LogLevel[LogLevel["ERROR"] = 400] = "ERROR";
    LogLevel[LogLevel["CRITICAL"] = 500] = "CRITICAL";
    LogLevel[LogLevel["ALERT"] = 550] = "ALERT";
    LogLevel[LogLevel["EMERGENCY"] = 600] = "EMERGENCY";
})(LogLevel || (LogLevel = {}));
var LogLevelStringsToConsoleFunction;
(function (LogLevelStringsToConsoleFunction) {
    LogLevelStringsToConsoleFunction["DEBUG"] = "debug";
    LogLevelStringsToConsoleFunction["INFO"] = "info";
    LogLevelStringsToConsoleFunction["NOTICE"] = "notice";
    LogLevelStringsToConsoleFunction["WARNING"] = "warn";
    LogLevelStringsToConsoleFunction["ERROR"] = "error";
    LogLevelStringsToConsoleFunction["CRITICAL"] = "critical";
    LogLevelStringsToConsoleFunction["ALERT"] = "alert";
    LogLevelStringsToConsoleFunction["EMERGENCY"] = "emergency";
})(LogLevelStringsToConsoleFunction || (LogLevelStringsToConsoleFunction = {}));
class TimingsCollection {
}
export class Logger {
    constructor() {
        this._timings = new TimingsCollection();
        this._debug = Logger.isDebugEnabled();
        /**
         * The current logging level, anything lower than this won't get logged.
         * @private
         */
        this._level = this._debug ? LogLevel.DEBUG : LogLevel.WARNING;
        this._timingEnabled = this._debug;
    }
    static get instance() {
        if (typeof Logger._instance === 'undefined') {
            this._instance = new Logger();
        }
        return this._instance;
    }
    /**
     * Verbose logging — DEBUG level, timings and console groups — is dev-only.
     * It is enabled when any of:
     *   - `window.DIZINER_DEBUG === true` (set from PHP when WP_DEBUG is on)
     *   - localStorage key `diziner_debug` === '1'
     *   - the URL query contains `diziner_debug`
     * Otherwise the logger stays quiet (warnings + errors only) so production
     * consoles are not flooded.
     * @private
     */
    static isDebugEnabled() {
        try {
            // Explicit localStorage opt-out wins over everything (silence it locally).
            if (typeof localStorage !== 'undefined') {
                const ls = localStorage.getItem('diziner_debug');
                if (ls === '0') {
                    return false;
                }
                if (ls === '1') {
                    return true;
                }
            }
            const w = window;
            if (w.DIZINER_DEBUG === true) {
                return true;
            }
            if (typeof window !== 'undefined' && window.location.search.indexOf('diziner_debug') !== -1) {
                return true;
            }
        }
        catch (e) {
            // Ignore restricted storage / non-browser contexts.
        }
        return false;
    }
    get level() {
        return this._level;
    }
    set level(value) {
        this._level = value;
    }
    get timingEnabled() {
        return this._timingEnabled;
    }
    set timingEnabled(value) {
        this._timingEnabled = value;
    }
    log(level, message) {
        // If this._level (100) > level (200), skip
        if (this._level > LogLevel[level]) {
            return;
        }
        const consoleLevel = LogLevelStringsToConsoleFunction[level];
        if (Object.prototype.hasOwnProperty.call(console, consoleLevel)) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            console[`${consoleLevel}`](message);
        }
    }
    info(message) {
        this.log('INFO', message);
    }
    warning(message) {
        this.log('WARNING', message);
    }
    error(message) {
        this.log('ERROR', message);
    }
    debug(message) {
        this.log('DEBUG', message);
    }
    /**
     * @todo Implement custom timers which work with console.
     */
    time(label = undefined) {
        if (!this.timingEnabled) {
            return;
        }
        if (typeof label !== 'undefined') {
            console.time(label);
        }
        else {
            console.time();
        }
    }
    /**
     * @todo Implement custom timers which work with console.
     */
    timeLog(label = undefined, data = undefined) {
        if (!this.timingEnabled) {
            return;
        }
        if (typeof label !== 'undefined' && typeof data !== 'undefined') {
            console.timeLog(label, data);
        }
        else if (typeof label !== 'undefined') {
            console.timeLog(label);
        }
        else {
            console.timeLog();
        }
    }
    /**
     * @todo Implement custom timers which work with console.
     */
    timeEnd(label) {
        if (!this.timingEnabled) {
            return;
        }
        console.timeEnd(label);
    }
    group(label) {
        if (!this._debug) {
            return;
        }
        console.group(label);
    }
    groupEnd() {
        if (!this._debug) {
            return;
        }
        console.groupEnd();
    }
}
export default Logger;
